import React from 'react';
import { Section } from './ui/Section';
export function Guarantee() {
  return <Section variant="alt" data-id="element-145">
      <div className="bg-gradient-card border border-brand-borderGlow/20 rounded-3xl p-8 md:p-12 text-center max-w-3xl mx-auto shadow-violet-glow" data-id="element-146">
        <div className="text-5xl mb-6" data-id="element-147">🛡️</div>
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-6 text-brand-title" data-id="element-148">
          Sin riesgo
        </h2>
        <p className="font-body text-xl text-brand-text leading-relaxed" data-id="element-149">
          7 días de garantía total. Si no mejora tu forma de enseñar, te
          devolvemos cada céntimo. Sin preguntas.
        </p>
      </div>
    </Section>;
}